import React from "react";
import { LANGUAGES } from "@/i18n/translations";
import { useLanguage } from "@/contexts/LanguageContext";

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const fontFor = (code) => {
    if (code === "ta") return "font-tamil";
    if (code === "ti") return "font-ethiopic";
    if (code === "ar") return "font-arabic";
    return "";
  };
  return (
    <div className="flex items-center gap-1" data-testid="language-switcher">
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-btn-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`text-xs font-bold uppercase tracking-[0.15em] px-3 py-2 border transition-colors ${
              active
                ? "bg-white text-black border-white"
                : "bg-transparent text-white/50 border-white/15 hover:border-white hover:text-white"
            } ${fontFor(l.code)}`}
            aria-pressed={active}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
